
import dHttp from '@/api/config.js'

/**
 * 通用数据获取
 * @param {string} url
 * @param {object} params
 */
export function getAction(url, params) {
    return dHttp({
        url: url,
        method: 'get',
        params: params
    })
}

export function getActionParams(url, params) {
    return dHttp({
        url: url,
        method: 'get',
        data: params
    })
}

/**
 * 通用数据提交
 * @param {string} url
 * @param {object} params
 */
export function postAction(url, params,timeout) {
    return dHttp({
        url: url,
        method: 'post',
        data: params,
        timeout:timeout || 5000,
    })
}
/**
 * 文件导出请求
 * @param url 请求地址
 * @param entity 请求参数
 * @returns {AxiosPromise} responseType
 */
export function exportEntity(url, entity) {
    return dHttp({
        url: url,
        method: 'post',
        data: entity,
        // timeout: 60000,
        responseType: 'blob'
    });
}
export default {
    getAction, getActionParams, postAction, exportEntity
}
